angular.module('aprima-core-ui').factory('MediaService', ['Bridge', function (Bridge) {
    'use strict';
    var id = 0;

    function getMedia (scope, pickerDescription, mediaCallback) {
        var mediaId = id++;
        Bridge.pickMedia(mediaId, pickerDescription);

        Bridge.on('mediaPicked', scope, function (value) {
            if(parseInt(value.Id) === mediaId) {
                mediaCallback(value.Media, value.FileName, value.Extension);
            }
        });
    }

    return {
        getMedia: getMedia
    };
}]);
